import React, { useEffect } from 'react';
import { sound } from './SoundSystem';

export default function ProjectModal({ project, onClose }) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  if (!project) return null;

  return (
    <div className="cyber-modal-overlay" onClick={onClose}>
      <div className="cyber-modal-container project-inspect-modal" onClick={(e) => e.stopPropagation()}>
        {/* Modal Header */}
        <div className="cyber-modal-header">
          <div className="modal-title-group">
            <span className="terminal-badge">INSPECTION_PROJET_3D</span>
            <h3>{project.title}</h3>
            <span className="project-cat-badge">{project.categoryLabel}</span>
          </div>

          <div className="modal-header-actions">
            {project.link && (
              <a 
                href={project.link} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="cyber-cta-btn primary"
                onClick={() => sound.playClick()}
              >
                <i className="fa-solid fa-arrow-up-right-from-square"></i>
                <span>Visiter la plateforme</span>
              </a>
            )}
            <button className="cyber-modal-close" onClick={onClose} title="Fermer">
              <i className="fa-solid fa-xmark"></i>
            </button>
          </div>
        </div>

        {/* Modal Body */}
        <div className="project-modal-body">
          <div className="project-modal-grid">
            {/* Left: High-Res Interactive Image Showcase */}
            <div className="project-banner-showcase">
              <div className="banner-frame-3d">
                <img src={project.image} alt={project.title} className="banner-img" />
                <div className="banner-scanline"></div>
                <div className="banner-corner-brackets"></div>
                <div className="banner-live-pill" style={{ borderColor: project.statusColor }}>
                  <span className="pulse-dot" style={{ backgroundColor: project.statusColor }}></span>
                  {project.status}
                </div>
              </div>
            </div>

            {/* Right: Technical Details & Architecture */}
            <div className="project-info-panel">
              <div className="info-block">
                <h4 className="info-section-title">
                  <i className="fa-solid fa-microchip"></i>
                  Architecture & Vue d'ensemble
                </h4>
                <p className="project-long-desc">{project.longDescription || project.description}</p>
              </div>

              {project.highlights && (
                <div className="info-block">
                  <h4 className="info-section-title">
                    <i className="fa-solid fa-star"></i>
                    Points Clés & Impact
                  </h4>
                  <ul className="project-highlights-list">
                    {project.highlights.map((h, idx) => (
                      <li key={idx}>
                        <i className="fa-solid fa-check"></i>
                        <span>{h}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              <div className="info-block">
                <h4 className="info-section-title">
                  <i className="fa-solid fa-layer-group"></i>
                  Stack Technologique
                </h4>
                <div className="project-tags-cloud">
                  {project.tags.map((tag, idx) => (
                    <span key={idx} className="tech-badge-chip">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>

              {project.link && (
                <div className="project-modal-cta">
                  <a 
                    href={project.link} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="cyber-cta-btn block-btn"
                    onClick={() => sound.playClick()}
                  >
                    <i className="fa-solid fa-globe"></i>
                    <span>Accéder au projet en ligne ({project.link})</span>
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
